// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { EElectionEventLockedDown } from "@sequentech/ui-core";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { IPermissions } from "@/types/keycloak";
export var EEventDataMode;
(function (EEventDataMode) {
    EEventDataMode["LOADING"] = "loading";
    EEventDataMode["UNAVAILABLE"] = "unavailable";
    EEventDataMode["EDIT"] = "edit";
    EEventDataMode["LOCKED_DOWN"] = "locked-down";
})(EEventDataMode || (EEventDataMode = {}));
/** Shared by the tab selector and its content so links cannot bypass the gates. */
export function useElectionEventDataMode(event) {
    var _a;
    var auth = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    if (!event)
        return EEventDataMode.LOADING;
    if (!tenantId ||
        event.tenant_id !== tenantId ||
        !auth.isAuthorized(true, tenantId, IPermissions.ELECTION_EVENT_DATA_TAB))
        return EEventDataMode.UNAVAILABLE;
    var lockdown = (_a = event.presentation) === null || _a === void 0 ? void 0 : _a.locked_down;
    if (lockdown === EElectionEventLockedDown.LOCKED_DOWN) {
        return auth.isAuthorized(true, tenantId, IPermissions.READINESS_CHECK)
            ? EEventDataMode.LOCKED_DOWN
            : EEventDataMode.UNAVAILABLE;
    }
    // Older events have no lockdown field. Unknown states must not open the editor.
    return lockdown == null || lockdown === EElectionEventLockedDown.NOT_LOCKED_DOWN
        ? EEventDataMode.EDIT
        : EEventDataMode.UNAVAILABLE;
}
